import { DocTemplatePropertySettings as IDocTemplatePropertySettings } from "@/api/models/doc-template-property-settings";
import { VideoListParams } from "@/getinfo-api/video";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

export interface _IDocTemplateCurrencySettings {
  type?: string;
  format?: string;
  currency_format?: string;
  number_format?: {
    enable?: boolean;
    decimals?: number;
    decimal_separator?: string;
    thousands_separator?: string;
  };
  number_to_words?: {
    enable?: boolean;
    locale?: string;
  };
  datetime_format?: string;
}

export interface ISettings
  extends Omit<IDocTemplatePropertySettings, "settings"> {
  settings: _IDocTemplateCurrencySettings;
}

export enum VuexVideoListParamsTypeEnum {
  owner = "owner",
  listener = "listener"
}

export interface VuexVideoListParams extends VideoListParams {
  type: VuexVideoListParamsTypeEnum;
}

export interface IPageSettings {
  headerIcon?: "add" | "edit" | "back" | null;
  headerIconTo?: any;
  isShowIcon?: boolean;
  header?: string;
  isFilterable?: boolean;
  disable?: boolean;
  breadCrumbs?: Array<any>;
}

export enum GlobalSettingsStorage {
  PasswordValidatorSettings = "password_validator"
}

export const LearningMaterialLocales = () => [
  {
    value: "ru-RU",
    label: i18n.tc(LocalesFields.RussianLanguage)
  },
  {
    value: "en-EN",
    label: i18n.tc(LocalesFields.EnglishLanguage)
  }
];
